import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ loading: true, paid: false, amount: null });

  useEffect(() => {
    if (!sessionId) {
      setState({ loading: false, paid: false, amount: null });
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setState({ loading: false, paid: true, amount: res.data.amount });
          return;
        }
      } catch (e) {
        // keep polling briefly
      }
      attempts += 1;
      if (attempts < 6) {
        setTimeout(poll, 2000);
      } else {
        setState({ loading: false, paid: false, amount: null });
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="mx-auto max-w-2xl px-4 pb-24 pt-40 text-center sm:px-6" data-testid="payment-success-page">
      {state.loading ? (
        <div>
          <Loader2 className="mx-auto h-12 w-12 animate-spin text-olive" />
          <h1 className="mt-6 font-serif text-3xl text-olive">Confirming your donation…</h1>
        </div>
      ) : state.paid ? (
        <div>
          <CheckCircle2 className="mx-auto h-16 w-16 text-olive" />
          <h1 data-testid="payment-confirmed-headline" className="mt-6 font-serif text-4xl text-olive">
            Thank you for funding <span className="italic text-burgundy">a fresh start.</span>
          </h1>
          <p className="mt-4 text-moss">
            Your donation of {state.amount ? `$${state.amount}` : "support"} helps cover pickups, storage,
            transportation, and delivery for families rebuilding their homes.
          </p>
          <Link to="/" data-testid="payment-home-link" className="btn-primary mt-8">Back to Home</Link>
        </div>
      ) : (
        <div>
          <XCircle className="mx-auto h-16 w-16 text-burgundy" />
          <h1 className="mt-6 font-serif text-4xl text-olive">We couldn't confirm your payment yet.</h1>
          <p className="mt-4 text-moss">
            If you completed checkout, your donation may still be processing. Questions? Email us at{" "}
            <a href="mailto:freshstartfurnishings@yahoo.com" className="font-semibold text-burgundy underline">
              freshstartfurnishings@yahoo.com
            </a>
          </p>
          <Link to="/support" data-testid="payment-retry-link" className="btn-accent mt-8">Back to Donations</Link>
        </div>
      )}
    </div>
  );
}
